import { StatusBar } from "expo-status-bar";
import {
  StyleSheet,
  Text,
  View,
  Image,
  TouchableOpacity,
  TextInput,
} from "react-native";
import { Icon } from "react-native-elements";
import { Button } from "react-native-paper";
import { useState } from "react";
import CarList from "./Cars/ListV2";

import { TextValues } from "../../constants/Strings";

const styles = StyleSheet.create({});

export default function Cars({ carData, setCarV, scrollV, carV }) {
  const [currIndex, setCurrIndex] = useState(0);
  const size = 10;

  const [searchText, setSearchText] = useState("");

  const [tempData, setTempData] = useState([]);

  const search = (query) => {
    if (query == "") {
      setSearchText("");
      setTempData([]);
      return;
    }
    setSearchText(query);
    let filteredData = carData.filter(function (item) {
      return item.name.toLowerCase().includes(query.toLowerCase());
    });
    setTempData(filteredData);
  };
  return (
    <View
      onLayout={(event) => setCarV(event.nativeEvent.layout)}
      style={{
        flexDirection: "column",
        paddingTop: 64,
      }}
    >
      <View
        style={{
          borderRadius: 16,
          flexDirection: "column",
          alignItems: "center",
          marginHorizontal: 20,
        }}
      >
        <Image
          resizeMode="cover"
          style={{
            width: "100%",
            height: 300,
            borderRadius: 16,
            position: "absolute",
            top: 0,
          }}
          source={require("../../assets/images/pattern.jpg")}
        />
        <View
          style={{
            borderRadius: 16,
            backgroundColor: "black",
            height: 300,
            position: "absolute",
            top: 0,
            width: "100%",
            opacity: 0.9,
          }}
        />
        <View
          style={{
            flexDirection: "column",
            paddingHorizontal: 32,
            paddingVertical: 54,
            alignItems: "center",
          }}
        >
          <Text
            style={{
              fontFamily: "Uber-Light",
              fontSize: 18,
              color: "white",
              textAlign: "center",
            }}
          >
            {TextValues.carCTA.description}
          </Text>
          <Text
            style={{
              fontFamily: "Uber-Bold",
              fontSize: 24,
              color: "white",
              textAlign: "center",
            }}
          >
            {TextValues.carCTA.heading}
          </Text>
        </View>

        <Image
          resizeMode="cover"
          style={{
            width: "100%",
            height: 200,
            borderBottomLeftRadius: 16,
            borderBottomRightRadius: 16,
          }}
          source={require("../../assets/images/people.jpg")}
        />
      </View>

      <View
        style={{ flexDirection: "column", marginTop: 64, marginHorizontal: 20 }}
      >
        <View style={{ flexDirection: "column" }}>
          <Text style={{ fontFamily: "Uber-Medium", fontSize: 24 }}>
            {TextValues.carSubHero.heading}
          </Text>
          <Text style={{ fontFamily: "Uber-Light", fontSize: 18 }}>
            {TextValues.carSubHero.description}
          </Text>
        </View>
        <View
          style={{
            flexDirection: "column",
            flex: 1,
            borderRadius: 16,
            padding: 12,

            marginTop: 36,
          }}
        >
          <View style={{ flexDirection: "column", flex: 1, marginRight: 16 }}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Icon color="orange" name="filter-outline" type="ionicon" />
              <Text
                style={{
                  fontFamily: "Uber-Medium",
                  marginLeft: 16,
                }}
              >
                Search
              </Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "column",
              marginTop: 8,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                borderColor: "#DBDBDB",
                borderRadius: 8,
                paddingLeft: 12,
                alignItems: "center",
                borderWidth: 1,
                flex: 1,
                marginRight: 24,
              }}
            >
              <Icon size={18} type="ionicon" name="search-outline" />
              <TextInput
                value={searchText}
                onChangeText={(txt) => search(txt)}
                style={{
                  paddingVertical: 12,
                  flex: 1,
                  paddingHorizontal: 8,
                  outlineStyle: "none",
                }}
                placeholder="Search car ... "
              />
            </View>
          </View>
        </View>
      </View>
      <View style={{ flexDirection: "row", alignItems: "center", margin: 20 }}>
        <Button
          color="orange"
          disabled={tempData.length > 0 || currIndex == 0}
          icon="chevron-left"
          onPress={() => {
            if (currIndex != 0) {
              let temp = currIndex - size;
              setCurrIndex(temp);
            }
          }}
        >
          Back
        </Button>

        <View
          style={{
            flexDirection: "column",
            alignItems: "center",
            flex: 1,
          }}
        >
          {tempData.length > 0 ? (
            <Text
              style={{
                fontFamily: "Uber-Medium",
                marginLeft: 16,
              }}
            >
              Showing search results
            </Text>
          ) : (
            <Text
              style={{
                fontFamily: "Uber-Medium",
                textAlign: "center",
              }}
            >
              Showing {currIndex + 1} -{" "}
              {carData.length > size
                ? currIndex + size < carData.length
                  ? currIndex + size
                  : carData.length
                : carData.length}{" "}
              of {carData.length}
            </Text>
          )}
        </View>
        <Button
          color="orange"
          disabled={
            tempData.length > 0 ||
            currIndex + size >= carData.length ||
            carData.length <= size
          }
          onPress={() => {
            let temp = currIndex + size;
            setCurrIndex(temp);
          }}
          icon="chevron-right"
        >
          Next
        </Button>
      </View>

      <CarList
        carData={
          tempData.length != 0
            ? tempData
            : carData.slice(currIndex, currIndex + size)
        }
      />
      <View style={{ flexDirection: "row", alignItems: "center", margin: 10 }}>
        <Button
          color="orange"
          disabled={tempData.length > 0 || currIndex == 0}
          icon="chevron-left"
          onPress={() => {
            if (currIndex != 0) {
              let temp = currIndex - size;
              setCurrIndex(temp);
              scrollV.current.scrollTo({
                x: 0,
                y: carV.y + 500,
                animated: true,
              });
            }
          }}
        >
          Back
        </Button>

        <View
          style={{
            flexDirection: "column",
            alignItems: "center",
            flex: 1,
          }}
        >
          {tempData.length > 0 ? (
            <Text
              style={{
                fontFamily: "Uber-Medium",
                marginLeft: 16,
              }}
            >
              Showing search results
            </Text>
          ) : (
            <Text
              style={{
                fontFamily: "Uber-Medium",
              }}
            >
              {" "}
              Showing {currIndex + 1} -{" "}
              {carData.length > size
                ? currIndex + size < carData.length
                  ? currIndex + size
                  : carData.length
                : carData.length}{" "}
              of {carData.length}
            </Text>
          )}
        </View>
        <Button
          color="orange"
          disabled={
            tempData.length > 0 ||
            currIndex + size >= carData.length ||
            carData.length <= size
          }
          onPress={() => {
            let temp = currIndex + size;
            setCurrIndex(temp);
            scrollV.current.scrollTo({
              x: 0,
              y: carV.y + 500,
              animated: true,
            });
          }}
          icon="chevron-right"
        >
          Next
        </Button>
      </View>
    </View>
  );
}
